<script lang="ts" setup>
import { useApplicationStore } from '@/stores/application'
import { storeToRefs } from 'pinia'
import type { PropType } from 'vue'
import CheckBoxField from '@/components/common/CheckBoxField.vue'
import { useValidationStore } from '@/stores/validation'
import { useDjangoAuthStore } from '@/stores/authDjango'
import type { ShipType } from '@/stores/type/ship.type'
import type { ValidationType } from '@/stores/type/validation.type'

const props = defineProps({
  ship: { type: Object as PropType<ShipType>, required: true }
})

const validationStore = useValidationStore()

const { items: apps } = storeToRefs(useApplicationStore())
const { user } = storeToRefs(useDjangoAuthStore())

const validationItems = computed<ValidationType[]>(() => {
  return props.ship?.validation_set ?? []
})

const disabled = computed<boolean>(() => {
  return !user.value?.is_superuser
})

function applicationName(applicationId: number): string {
  return apps.value.find((app) => app.id === applicationId)?.name ?? ''
}

function updateValidation(value: boolean, validation: ValidationType) {
  validation.approved = value
  validationStore.update(validation)
}

const emit = defineEmits<{ (e: 'click'): void }>()
</script>

<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <v-btn icon="mdi-list-status" v-bind="props" variant="text" @click="emit('click')"> </v-btn>
    </template>
    <v-card width="auto">
      <v-list density="compact">
        <template v-for="validation in validationItems">
          <v-list-item class="pl-2 py-0">
            <v-list-item-title>
              <CheckBoxField
                :disabled="disabled"
                :item="validation"
                :label="applicationName(validation.application)"
                parameter="approved"
                @set="(value: boolean) => updateValidation(value, validation)"
              />
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
  </v-menu>
</template>

<style scoped>
:deep(.v-input__control) {
  font-size: 14px !important;
}
:deep(.v-label) {
  font-size: 14px !important;
  opacity: 1;
}
</style>
